import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ramadan20-pubg',
  templateUrl: './ramadan20-pubg.component.html',
  styleUrls: ['./ramadan20-pubg.component.css']
})
export class Ramadan20PubgComponent implements OnInit {

  gameName = "pubg";
  constructor() { }

  ngOnInit() {
  }

}
